import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { DiaryEntry } from './components/DiaryEntry';
import { ProductExplanation } from './components/ProductExplanation';
import { ExpertQuote } from './components/ExpertQuote';
import { Testimonials } from './components/Testimonials';
import { BeforeAfter } from './components/BeforeAfter';
import { TrustBar } from './components/TrustBar';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];
    w[l].push({'gtm.start':new Date().getTime(),
    event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='
    +i+dl;f.parentNode.insertBefore(j,f);})(window,document,
    'script','dataLayer','GTM-KZBZMFT');`;
    document.head.appendChild(script);
    const gclid = new URLSearchParams(window.location.search).get('gclid');
    if (gclid) {
      document.querySelectorAll('a[href*="hunderunde.shop"]').forEach(link => {
        const el = link as HTMLAnchorElement;
        const sep = el.href.includes('?') ? '&' : '?';
        el.href = el.href + sep + 'gclid=' + gclid;
      });
    }
  }, []);
  return <div className="min-h-screen bg-cream selection:bg-forest selection:text-cream overflow-x-hidden" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />

        <section className="py-12 px-4 max-w-4xl mx-auto" data-id="element-4">
          <DiaryEntry title="Der Alltag" date="12. Dezember 2025" text="Bella hat wieder Durchfall. Zum dritten Mal diese Woche. Ich putze den Garten, wasche ihre Decke, mache mir Sorgen. Der Tierarzt verschreibt Schonkost. Es hilft – aber nur kurz. Kaum wechsle ich das Futter, geht es von vorne los. Ich bin am Ende." delay={0.1} data-id="element-5" />

          <DiaryEntry title="Die Entdeckung" date="22. Januar 2026" text="Eine Kollegin erzählt mir von einem Futtertopping, das sie ihrem Labrador gibt. Pflanzlich, keine Zusätze, mit Präbiotika und Ballaststoffen. Ich googele stundenlang. Lese Erfahrungsberichte. Bestelle es schließlich – mit wenig Hoffnung aber großer Verzweiflung." delay={0.2} data-id="element-6" />

          <DiaryEntry title="Die ersten Tage" date="29. Januar 2026" text="Ich schleiche das Topping langsam ein wie empfohlen. Erstmal ein kleiner Löffel. Bella frisst es problemlos. Nach 5 Tagen: der Stuhl wird fester. Ich traue meinen Augen kaum. Nach 2 Wochen: kein einziger Durchfall mehr. Ich weine vor Erleichterung." delay={0.3} data-id="element-7" />

          <DiaryEntry title="Heute" date="13. März 2026" text="Bella bekommt das Topping jeden Morgen ins Futter. Es ist Teil unserer Routine geworden. Sie liebt es, ich liebe die Ruhe. Keine Angst mehr vor dem Morgen. Endlich können wir wieder entspannt spazieren gehen." image="https://images.unsplash.com/photo-1612774412771-005ed8e861d2?w=800&q=80" delay={0.4} data-id="element-8" />
        </section>

        <ProductExplanation data-id="element-9" />
        <ExpertQuote data-id="element-10" />
        <Testimonials data-id="element-11" />
        <BeforeAfter data-id="element-12" />
        <TrustBar data-id="element-13" />
        <CTASection data-id="element-14" />
      </main>

      <Footer data-id="element-15" />
    </div>;
}